import React from 'react';
import { Target, BarChart3, Brain, Zap } from 'lucide-react';
import '../styles/Skills.css';

const Skills = () => {
  const skills = [
    {
      id: 'search-performance',
      icon: Target,
      title: 'Search Engine & Performance Marketing',
      description: 'Managing high-ticket Google Ads, Meta Ads, LinkedIn Ads, and Programmatic Ads ecosystems. Balancing Brand and Non-Brand Search to prevent budget cannibalization.',
      tags: ['Google Ads', 'Meta Ads', 'LinkedIn Ads', 'Programmatic']
    },
    {
      id: 'analytics-attribution',
      icon: BarChart3,
      title: 'Advanced Analytics & Attribution',
      description: 'Deep expertise in Google Tag Manager, GA4, and Server-Side tracking. Moving beyond last-click to focus on Marketing Efficiency Ratio (MER) and incremental lift.',
      tags: ['GA4', 'GTM', 'Server-Side', 'MER']
    },
    {
      id: 'ai-integration',
      icon: Brain,
      title: 'AI Tools Integration',
      description: 'Deploying AI for predictive analytics, automated personalization, and rapid scaling to bypass traditional bottlenecks and deliver exponential growth.',
      tags: ['Predictive AI', 'Automation', 'Personalization', 'Prompt Eng.']
    },
    {
      id: 'cro-optimization',
      icon: Zap,
      title: 'Conversion Rate Optimization (CRO)',
      description: 'Integrating UI/UX design collaboration, marketing automation, CRM setup, and landing page optimization to stop funnel leakage.',
      tags: ['CRO', 'UI/UX', 'CRM', 'Landing Pages']
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="skills-container">
        <div className="skills-header reveal">
          <div className="section-label">Core Competencies</div>
          <h2 className="section-title">What I Deliver as Your Performance Marketing Consultant</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="skills-grid">
          {skills.map((skill) => {
            const IconComponent = skill.icon;
            return (
              <div key={skill.id} className="skill-card reveal">
                <div className="skill-icon-wrapper">
                  <IconComponent className="skill-icon" size={32} />
                </div>
                <h3 className="skill-title">{skill.title}</h3>
                <p className="skill-description">{skill.description}</p>
                <div className="skill-tags">
                  {skill.tags.map((tag) => (
                    <span key={tag} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
